/*
*
* File JS per il TPL Newsletter
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './newsletter-page.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const modifyHtmlFormMailup = () => {
    let mailupForm = document.querySelector('.mupwp-form');

    if (!mailupForm) return;

    let allInputFields = mailupForm.querySelectorAll('.mupwp-form-field');

    allInputFields.forEach(formGroup => {

        formGroup.classList.add('float-label');
        
        // Aggiunta placeholder su input e textarea
        let insideInput = formGroup.querySelector('input');
        let insideTextarea = formGroup.querySelector('textarea');

        if (insideInput)
        {
            insideInput.placeholder = 'field';
        }
        if (insideTextarea)
        {
            insideTextarea.placeholder = 'field';
        }

        // Modifica ordine label / input
        let insideLabel = formGroup.querySelector('label');

        if (insideLabel)
        {
            formGroup.removeChild(insideLabel);
            formGroup.appendChild(insideLabel);
        }
    }); 
}
modifyHtmlFormMailup();

//--------------------------------------------------------------------//